import React from "react";

import { getDocument } from "@thelabnyc/thelabui/src/utils/dom";

import {
    IFormUUID,
    IReviewsBrandID,
    IWebPageURL,
    isoReviewsProductID,
    isoReviewsProductVariantID,
} from "../../../models/nominals";
import { getInteger } from "../../../utils/numbers";
import { useAppDispatch, useAppSelector } from "../../reducers";
import { WriteReviewFormMode } from "../constants";
import { defaultState } from "../defaults";
import { WriteReviewForm } from "../elements/WriteReviewForm";
import { WriteReviewThankYou } from "../elements/WriteReviewThankYou";
import { registerNewWriteReviewForm } from "../reducers";
import { loadProducts } from "../thunks";

interface IProps {
    formUUID: IFormUUID;
    brandID: IReviewsBrandID;
    brand?: string;
    returnURL?: IWebPageURL;
}

export const SingleProductWriteReviewForm = (
    props: IProps,
): React.ReactNode => {
    const dispatch = useAppDispatch();

    const loadedInitialProducts = useAppSelector((rootState) => {
        const state = rootState.reviews || defaultState;
        return state.data.loadedInitialProducts;
    });

    const productTypeIDs = useAppSelector((rootState) => {
        const state = rootState.reviews || defaultState;
        return state.ui.productTypeIDs;
    });

    const facetValues = useAppSelector((rootState) => {
        const state = rootState.reviews || defaultState;
        return state.ui.facetValues;
    });

    const onReviewSubmit = () => {
        const document = getDocument();
        if (!document) {
            return;
        }
        const reviewModuleTitle = document.querySelector(
            ".write-review-button__container",
        );
        reviewModuleTitle?.scrollIntoView({ behavior: "smooth" });
    };

    React.useEffect(() => {
        dispatch(
            registerNewWriteReviewForm({
                formUUID: props.formUUID,
                mode: WriteReviewFormMode.FORM_OPEN,
            }),
        );

        void dispatch(loadProducts(props.brandID));
    }, [dispatch, props.formUUID, props.brandID]);

    if (!loadedInitialProducts) {
        return null;
    }

    const defaultProductTypeID = productTypeIDs[0];
    const defaultProductID = isoReviewsProductID.wrap(
        getInteger(facetValues.product_id, 0),
    );
    const defaultProductVariantID = isoReviewsProductVariantID.wrap(
        getInteger(facetValues.product_variant_id, 0),
    );

    return (
        <div className="write-review-button__container">
            <WriteReviewThankYou formUUID={props.formUUID} />
            <WriteReviewForm
                formUUID={props.formUUID}
                formTitle={"Choose your product"}
                brand={props.brand}
                onReviewSubmit={onReviewSubmit}
                defaultProductTypeID={defaultProductTypeID}
                defaultProductID={defaultProductID}
                defaultProductVariantID={defaultProductVariantID}
                returnURL={props.returnURL}
            />
        </div>
    );
};
